export default __webpack_public_path__ + "static/media/track-distance-icon.618f72d0.svg";